export const RESET = 'EXCMDEVICETYPE_UPDATE_RESET'
export const SET_ERROR = 'EXCMDEVICETYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMDEVICETYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMDEVICETYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMDEVICETYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMDEVICETYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMDEVICETYPE_UPDATE_UPDATE_RETRIEVED'
